import { SnackbarKey, SnackbarProvider } from "notistack";
import { VariantType, useSnackbar } from "notistack";
import React, { RefObject } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

export enum Serverity {
  Error = "error",
  Warning = "warning",
  Info = "info",
  Success = "success",
  Default = "default",
}

type MessageProviderContext = {
  showMessage: (serverity: Serverity, message: string) => void;
  showError: (message: string) => void;
  showWarning: (message: string) => void;
  showInfo: (message: string) => void;
  showSuccess: (message: string) => void;
};

let messageProvider: MessageProviderContext;

export const useMessageProvider = () => {
  const { enqueueSnackbar } = useSnackbar();

  if (!messageProvider) {
    messageProvider = {
      showMessage: (serverity: Serverity, message: string) => {
        enqueueSnackbar(message, { variant: serverity as VariantType });
      },
      showError: (message: string) => {
        enqueueSnackbar(message, { variant: Serverity.Error, autoHideDuration: 10000 });
      },
      showWarning: (message: string) => {
        enqueueSnackbar(message, { variant: Serverity.Warning });
      },
      showInfo: (message: string) => {
        enqueueSnackbar(message, { variant: Serverity.Info });
      },
      showSuccess: (message: string) => {
        enqueueSnackbar(message, { variant: Serverity.Success });
      },
    };
  }

  return messageProvider;
};

export const MessageProvider = ({ children }: { children: React.ReactNode }) => {
  const notistackRef = React.createRef() as RefObject<SnackbarProvider>;
  const handleClose = (key: SnackbarKey) => () => {
    notistackRef.current!.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={3}
      autoHideDuration={4000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      action={(key) => (
        <IconButton onClick={handleClose(key)}>
          <CloseIcon />
        </IconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  );
};
